<template>
  <fieldset class="step step--6">
    <Section :title="stepTitle">
      <CertificationFormGroup name="q_6_1">
        <TrueFalseControl
          id="q_6_1"
          v-model="form.q_6_1"
          number="1"
          label="Opłata rejestracyjna obejmuje udział uczestników w programie pozamerytorycznym (rozrywkowym)"
          help="Elementy&nbsp;pozamerytoryczne/rozrywkowe, m.in: tańce lub takie wydarzenia, podczas których główną atrakcją jest muzyka na żywo, wycieczki krajoznawcze, spektakle teatralne, wydarzenia sportowe (np. narty, golf lub mecze piłki nożnej) i inne wydarzenia relaksacyjne. Dla uniknięcia wątpliwości, podkład muzyczny w tle nie stanowi Rozrywki."
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="q_6_2">
        <TrueFalseControl
          id="q_6_2"
          v-model="form.q_6_2"
          number="2"
          label="W skład pakietu rejestracyjnego dla uczestników wchodzi zakwaterowanie"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <transition name="slide-fade">
        <CertificationFormGroup v-show="form.q_6_2" name="q_6_2a">
          <TrueFalseControl
            id="q_6_2a"
            v-model="form.q_6_2a"
            number="2a"
            label="Zakwaterowanie jest w tym samym obiekcie/obiektach, w których odbywa się wydarzenie"
            :disabled="formDisabled"
          />
        </CertificationFormGroup>
      </transition>
      <transition name="slide-fade">
        <div
          v-show="form.q_6_2 && form.q_6_2a === false"
          class="CertificationFormGroup"
        >
          <CustomControl
            id="2b"
            label="Podaj miejsce zakwaterowania"
            number="2b"
            :disabled="formDisabled"
          />
          <CertificationFormAccommodations
            id="accommodations"
            v-model="form.accommodations"
            :disabled="formDisabled"
          />
        </div>
      </transition>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import CustomControl from "@/components/Controls/CustomControl";
import TrueFalseControl from "@/components/Controls/TrueFalseControl";
import CertificationFormAccommodations from "./CertificationFormAccommodations";

export default {
  name: "CertificationFormStep6",
  components: {
    CustomControl,
    TrueFalseControl,
    CertificationFormAccommodations
  },
  extends: BaseCertificationFormStep
};
</script>
